module.exports = __webpack_public_path__ + "img/Wp_2067.0c04b418.png";